import ExecutiveSummaryPage from "../components/ExecutiveSummary/ExecutiveSummaryPage";
import SiteAnalyticsPage from "../components/SiteAnalyticsPage";
import Compass from "../components/Compass";
import RetentionPage from "../components/RetentionPage";
import PaidMediaPage from "../components/Paidmedia/PaidMediaPage";
import KlaviyoAcquisitionPage from "../components/KlaviyoAcquisitionPage";
import BulkUpload from "../components/BulkUpload/BulkUpload";
import WhitelistedMediaComparison from "../components/WhitelistedMediaComparison/WhitelistedMediaComparison";
import BudgetPlannerPage from "../components/BudgetPlanner/BudgetPlannerPage";
import OverviewPage from "../components/Performance/OverviewPage";
import ContentPage from "../components/Influencer/ContentPage";
import CreativeSummaryPage from "../components/Influencer/CreativeSummaryPage";
import OutreachPage from "../components/Influencer/InfluencerOutreach";
import MarketingReportingOverallPage from "../components/Performance/MarketingReportingOverallPage";
import MarketingReportingPlatformPage from "../components/Performance/MarketingReportingPlatformPage";
import NewSiteAnalyticsPage from "../components/Performance/SiteAnalyticsPage";
import NotificationHookTest from "../components/NotificationTest";
import CustomerPerformancePage from "../components/Performance/CustomerPerformance/CustomerPerformancePage";
import ProductPerformancePage from "../components/Performance/ProductPerformance/ProductPerformancePage";
import PageContentSettingsPage from "../components/Settings/PageContentSettingsPage";
import ProductGroupingSettingsPage from "../components/Settings/ProductGroupingSettingsPage";
import BudgetPlannerSettingsPage from "../components/Settings/BudgetPlannerSettingsPage";
import MarketingSettingsPage from "../components/Settings/MarketingSettingsPage";
import ExtraCostsSettingsPage from "../components/Settings/ExtraCostsSettingsPage";
import CompassMultiplierSettingsPage from "../components/Settings/CompassMultiplierSettingsPage";
import AIHealthPage from "../components/SEO/AIHealthPage";
import CampaignMappingsSettingsPage from "../components/Settings/CampaignMappingsSettingsPage";
import CompassPortalPage from "../components/CompassPortal/CompassPortalPage";

const ROUTE_CONFIG = {
  executive_summary: {
    path: "/executive-summary",
    element: ExecutiveSummaryPage,
  },
  site_analytics: [
    {
      path: "/site-analytics",
      element: SiteAnalyticsPage,
    },
    {
      path: "/performance/site-analytics",
      element: NewSiteAnalyticsPage,
    },
  ],
  compass: {
    path: "/compass",
    element: Compass,
  },
  ltr: {
    path: "/customer-analytics",
    element: RetentionPage,
  },
  paid_media: {
    path: "/paid-media",
    element: PaidMediaPage,
  },
  klaviyo: {
    path: "/klaviyo-acquisition",
    element: KlaviyoAcquisitionPage,
  },
  bulk_upload: {
    path: "/bulk-upload",
    element: BulkUpload,
  },
  whitelisted_media: {
    path: "/whitelisted-media-comparison",
    element: WhitelistedMediaComparison,
  },
  budget_planner: {
    path: "/target-settings",
    element: BudgetPlannerPage,
  },
  overview: {
    path: "/performance/overview",
    element: OverviewPage,
  },
  ai_health: {
    path: "/seo/ai-health",
    element: AIHealthPage,
  },
  influencer_media: {
    path: "/influencer/content",
    element: ContentPage,
  },
  creative_summary: {
    path: "/influencer/creative-summary",
    element: CreativeSummaryPage,
  },
  outreach_summary: {
    path: "/influencer/outreach-summary",
    element: OutreachPage,
  },
  marketing_reporting: [
    {
      path: "/performance/marketing-reporting",
      element: MarketingReportingOverallPage,
    },
    {
      path: "/performance/marketing-reporting/:platform",
      element: MarketingReportingPlatformPage,
    },
  ],
  customer_performance: [
    {
      path: "/performance/customer-performance",
      element: () => <CustomerPerformancePage />,
    },
  ],
  product_performance: [
    {
      path: "/performance/product-performance",
      element: () => <ProductPerformancePage />,
    },
  ],
  test: [
    {
      path: "/tests/notification-test",
      element: () => <NotificationHookTest />,
    },
  ],
  page_content_settings: {
    path: "/settings/page-content",
    element: PageContentSettingsPage,
  },
  product_grouping_settings: {
    path: "/settings/product-grouping",
    element: ProductGroupingSettingsPage,
  },
  budget_planner_settings: {
    path: "/settings/target-settings",
    element: BudgetPlannerSettingsPage,
  },
  marketing_settings: {
    path: "/settings/marketing",
    element: MarketingSettingsPage,
  },
  extra_costs_settings: {
    path: "/settings/extra-costs",
    element: ExtraCostsSettingsPage,
  },
  campaign_mappings_settings: {
    path: "/settings/campaign-mappings",
    element: CampaignMappingsSettingsPage,
  },
  compass_multiplier_settings: {
    path: "/settings/compass-multipliers",
    element: CompassMultiplierSettingsPage,
  },
  bulk_uploader: {
    path: "/bulk-uploader",
    element: BulkUpload,
  },
  compass_portal: {
    path: "/compass-portal/*",
    element: CompassPortalPage,
  },
  // admin_settings: {
  //   path: "/settings/admin",
  //   element: AdminSettingsPage,
  // },
};

export default ROUTE_CONFIG;
